import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import './newMeetingModal.scss'
import { useEffect, useState } from 'react';
import { DialogActions, TextField, } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import AddHomeRoundedIcon from '@mui/icons-material/AddHomeRounded';
import { useNavigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../../../store/hooks/hooks';
import { StudentActions } from '../../../../store/StudentAction';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import AdminApi from '../../../../store/services/admin';
import AutoCompletePeople from './autoComplete/autoComplete';
import { getEvents } from '../../../../store/adminActions';
import { createNotifictions } from '../../../../utils/helperFunction';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function NewEventModal() {
    const [open, setOpen] = React.useState(false)
    const [eventName, setEventName] = useState("")
    const [location, setLocation] = useState("")
    const [meetingUrl, setMeetingUrl] = useState("")
    const userDetails = useAppSelector((state: any) => state.user.user)
    const studentsList = useAppSelector((state: any) => state.admin.placements)
    const [participantList, setPartcipantList] = useState<any[]>([]);
    const events = useAppSelector((state: any) => state.admin.events)
    const [from, setFrom] = React.useState<Dayjs | null>(null);
    const [to, setTo] = React.useState<Dayjs | null>(null);
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState("")
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const reset = () => {
        setFrom(dayjs(new Date()))
        setTo(dayjs(new Date()))
        setLocation("")
        setMeetingUrl("")
        setEventName("")
        setPartcipantList([])
    }
    const checkEvent = () => {
        return events.filter((elm: any) => {
            console.log(elm)
            return elm.details.title === eventName && elm.details.location === location && dayjs(elm.details.From).format('LLL').toString() === dayjs(from?.toString()).format('LLL').toString() && dayjs(elm.details.To).format('LLL').toString() === dayjs(to?.toString()).format('LLL').toString() && JSON.stringify(elm.details.participants) === JSON.stringify([{ ...userDetails.result }, ...participantList])
        })
    }
    const handleSubmit = async (e: any) => {
        if (checkEvent().length > 0) {
            dispatch(StudentActions.setMessage("Event already present.Please try with new values"))
        }
        else {
            setIsLoading(true)
            e.preventDefault()
            let body = {
                EventType: "TM",
                userId: userDetails.result.Id,
                details: {
                    dateApplied: new Date(),
                    From: from,
                    To: to,
                    location: location,
                    meetingUrl: meetingUrl,
                    title: eventName,
                    participants: [{ ...userDetails.result }, ...participantList],
                    rejectedParticipants: [],
                    acceptedParticipants: [userDetails.result.Id]
                }
            }
            AdminApi.newEventRequest(body).then(async res => {
                dispatch(StudentActions.setMessage("Meeting Generated"))
                participantList.forEach((elm: any) => {
                    createNotifictions({
                        target: elm.Student_ID,
                        message: `${eventName} meeting was scheduled by ${userDetails.result.first_name} ${userDetails.result.last_name} `,
                        type: "TM",
                        eventId: res.data._id
                    })
                })
                await dispatch(getEvents("TM"))
                setIsLoading(false)
            }).catch((e) => {
                console.log(e)
                if (e.response.status === 403) {
                    navigate('/login')
                }
                setIsLoading(false)
                reset()
                dispatch(StudentActions.setMessage("Request Generation Failed.Try again."))
            })
        }

    }
    useEffect(() => {
        reset()
        handleClose()
    }, [isLoading])
    useEffect(() => {
        if (eventName.length === 0) {
            setError("*Please enter a event name.")
        }
        else if (participantList.length === 0) {
            setError("*Please add some participants.")
        }
        else if (location.length === 0) {
            setError("*Please enter a location")
        }
        else if (dayjs(from?.toString()).format('LLL').toString() === dayjs(to?.toString()).format('LLL').toString()) {
            setError("*Event start time is same as the end time")
        }
        else if (new Date(dayjs(to?.toString()).toString()) < new Date(dayjs(from?.toString()).toString())) {
            setError("*Event start time is greater than end time")
        }
        else {
            setError("")
        }
    }, [eventName, participantList,location,from,to])
    return (
        <div>
            <Button variant="outlined" onClick={handleClickOpen} startIcon={<AddRoundedIcon />}>
                New Meeting
            </Button>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                className='w-100'
                fullWidth
                maxWidth="md"
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>New Event</DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSubmit}>
                        <div>
                            <div className='flex flex-column'>
                                <div className='flex flex-column m-2'>
                                    <label className='required'>Event Name:</label>
                                    <input value={eventName} onChange={(e) => {
                                        setEventName(e.target.value)
                                    }}></input>
                                </div>
                                <div className='flex flex-column m-2'>
                                    <AutoCompletePeople people={studentsList} list={[]} admin={userDetails} valueChange={(participants: any) => {
                                        setPartcipantList([...participants])
                                    }}></AutoCompletePeople>
                                </div>

                                <div className='flex flex-column m-2'>
                                    <label className='required'>Location:</label>
                                    <input value={location} onChange={(e) => {
                                        setLocation(e.target.value)
                                    }}></input>
                                </div>
                                <div className='flex justify-content-between'>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <div className='flex flex-column m-2 w-50'>
                                            <label className='required'>From</label>
                                            <DateTimePicker
                                                value={from}
                                                minDateTime={dayjs(new Date())}
                                                onChange={(newValue: Dayjs | null) => {
                                                    setFrom(newValue)
                                                }}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </div>
                                        <div className='flex flex-column m-2 w-50'>
                                            <label className='required'>To</label>
                                            <DateTimePicker
                                                value={to}
                                                minDateTime={dayjs(from ? from : undefined)}
                                                onChange={(newValue: Dayjs | null) => {
                                                    setTo(newValue)
                                                }}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </div>
                                    </LocalizationProvider>
                                </div>
                                <div className='flex flex-column m-2'>
                                    <label>Meeting URL:</label>
                                    <input value={meetingUrl} onChange={(e) => {
                                        setMeetingUrl(e.target.value)
                                    }}></input>
                                </div>
                            </div>
                        </div>
                    </form>
                </DialogContent>
                <DialogActions className='flex justify-content-between'>
                    <p className='font-weight-700 m-0 mx-3 text-danger'>{error}</p>
                    <div className='flex'>
                        <Button onClick={handleClose}>Cancel</Button>
                        <LoadingButton
                            loading={isLoading}
                            loadingPosition="start"
                            onClick={handleSubmit}
                            startIcon={<AddHomeRoundedIcon />}
                            variant="contained"
                            disabled={eventName.length === 0 || participantList.length === 0 || location.length === 0 || dayjs(from?.toString()).format('LLL').toString() === dayjs(to?.toString()).format('LLL').toString() || new Date(dayjs(to?.toString()).toString()) < new Date(dayjs(from?.toString()).toString())} autoFocus
                        >
                            Create Meeting
                        </LoadingButton>

                    </div>

                </DialogActions>
            </Dialog>
        </div>
    );
}